// The URL is the single source of truth for the project and branch: every page of the app lives under
// /p/<slug>/b/<branch>/<page...> (the same paths as cortex's, so a companion's links work in both).
export const DEFAULT_BRANCH = 'main';

export function projectPath(page: string, slug: string | null, branch?: string | null): string {
  const clean = page.replace(/^\/+/, '');
  if (!slug) return `/${clean}`;
  const base = `/p/${encodeURIComponent(slug)}/b/${encodeURIComponent(branch || DEFAULT_BRANCH)}`;
  return clean ? `${base}/${clean}` : `${base}/apps`;
}

export function parseProjectPath(pathname: string): {
  slug: string | null;
  branch: string | null;
  rest: string;
} {
  const parts = pathname.split('/').filter(Boolean);
  let slug: string | null = null;
  let branch: string | null = null;
  let rest = parts;
  if (parts[0] === 'p' && parts[1]) {
    slug = decodeURIComponent(parts[1]);
    rest = parts.slice(2);
    if (rest[0] === 'b' && rest[1]) {
      branch = decodeURIComponent(rest[1]);
      rest = rest.slice(2);
    }
  }
  return { slug, branch, rest: rest.join('/') };
}
